import { EventEmitter } from '@angular/core';
import { Campaign } from '../../../../models/campaign';
import { CampaignService } from '../../../services/campaign/campaign.service';
import { NumberUtils } from '../../../utils/number.utils';
import { CampaignInfluencerStatus } from '../../../app.constants';
import { UserService } from '../../../services/user.service';
import { ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../../services/cache/cache.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppSettings } from '../../../utils/app-settings';
var CampaignItemComponent = /** @class */ (function () {
    function CampaignItemComponent(campaignService, deviceService, userService, cacheService, route, eventTracker, translate) {
        this.campaignService = campaignService;
        this.deviceService = deviceService;
        this.userService = userService;
        this.cacheService = cacheService;
        this.route = route;
        this.eventTracker = eventTracker;
        this.translate = translate;
        this.eventSelectCampaign = new EventEmitter();
        this.eventDeleteCampaign = new EventEmitter();
        this.eventReloadSelectedCampaign = new EventEmitter();
        this.eventOpenAddInfluencer = new EventEmitter();
        this.eventOpenMeasurePage = new EventEmitter();
        this.goToCampaignDetails = new EventEmitter();
    }
    CampaignItemComponent.prototype.ngOnInit = function () {
    };
    CampaignItemComponent.prototype.fetchInfluencerByCampaign = function (campaign, toggle) {
        var _this = this;
        if (toggle === void 0) { toggle = true; }
        var campaignId = campaign.id;
        this.cacheService.get("campaign_influencers_" + campaignId, this.campaignService.getInfluencerByCampaign(campaignId)).subscribe(function (res) {
            _this.campaignService.updateCampaignDetailsData(_this.campaign, res);
        });
    };
    CampaignItemComponent.prototype.selectCampaign = function (campaign) {
        if (this.deviceService.isMobile()) {
            this.openCampaignDetails(campaign.id, campaign.campaignInfluencerId, true);
        }
        else {
            this.expandCampaignInfluencerList(campaign);
        }
    };
    CampaignItemComponent.prototype.expandCampaignInfluencerList = function (campaign) {
        var isExpaned = campaign.is_expanded;
        this.eventSelectCampaign.emit(campaign);
        // Report event to Segment/MP
        this.campaign.is_expanded = !isExpaned;
        if (!isExpaned) {
            // segment track event
            this.eventTracker.trackUserAction(UserActionType.ACTION, Page.CAMPAIGN, {
                id: campaign.id,
                name: campaign.name,
                type: TargetType.CAMPAIGN_DETAILS
            }, {
                action: UserActionType.TOGGLE,
                source: ActionSource.PAGE,
            }, undefined, {
                type: this.isCampaignHistory ? ActivePages.CAMPAIGN_HISTORY : ActivePages.CAMPAIGN_OVERVIEW
            });
        }
    };
    CampaignItemComponent.prototype.deleteCampaign = function (campaign) {
        this.eventDeleteCampaign.emit(campaign);
    };
    CampaignItemComponent.prototype.reloadCampaign = function () {
        this.cacheService.clear("campaign_influencers_" + this.campaign.id);
        this.fetchInfluencerByCampaign(this.campaign, false);
    };
    CampaignItemComponent.prototype.normalizeNumberData = function (value) {
        if (!value || (this.enableInfluencerPlatform && this.isNewCampaign(this.campaign))) {
            return '0';
        }
        return NumberUtils.normalizeNumberToString(value);
    };
    CampaignItemComponent.prototype.getInfluencerPostCount = function (campaign) {
        if (this.enableInfluencerPlatform && this.isNewCampaign(this.campaign)) {
            return 0;
        }
        return campaign.numberOfPosts;
    };
    CampaignItemComponent.prototype.getNewPublishedPostCount = function (campaign) {
        if (this.enableInfluencerPlatform && this.isNewCampaign(this.campaign)) {
            return null;
        }
        return campaign.newPosts;
    };
    CampaignItemComponent.prototype.openAddInfluencer = function (event) {
        this.selectCampaign(this.campaign);
        this.eventOpenAddInfluencer.emit(this.campaign);
    };
    CampaignItemComponent.prototype.openMeasurePage = function (event) {
        this.eventOpenMeasurePage.emit(this.campaign);
    };
    CampaignItemComponent.prototype.openCampaignDetails = function (campaignId, campaignInfluencerId, onMobile) {
        this.cacheService.disableCacheRemoving();
        // if current user is influencer, should open specific campaign details page for influencer
        var statusActive = [CampaignInfluencerStatus.ACTIVE.toLocaleLowerCase()];
        if (this.enableInfluencerPlatform) {
            if (statusActive.indexOf(this.campaign.status.toLocaleLowerCase()) >= 0 && !onMobile) {
                return this.route.navigate(['dashboard', 'campaigns', campaignInfluencerId, 'active']);
            }
            else {
                if (this.isNewCampaign(this.campaign)) {
                    return this.route.navigate(['dashboard', 'campaigns', campaignId, 'new'], {
                        queryParams: {
                            isNewCampaign: true
                        }
                    });
                }
                else {
                    return this.route.navigate(['dashboard', 'campaigns', campaignId, 'new']);
                }
            }
        }
        else if (this.isCampaignHistory) {
            return this.route.navigate(['campaigns', campaignId], {
                queryParams: {
                    activeAccount: this.activeAccount,
                    isCampaignHistory: this.isCampaignHistory
                }
            });
        }
        else {
            // otherwise open the default campaign page
            return this.route.navigate(['campaigns', campaignId], {
                queryParams: {
                    activeAccount: this.activeAccount
                }
            });
        }
    };
    CampaignItemComponent.prototype.getCampaignDetailButtonColorClass = function (campaign) {
        var status = (campaign.status + '').toLowerCase();
        // Todo: I don't know actual statuses and logic to get status here
        // Should correctly implement mapping status to button color
        var colors = {
            'invited': 'blue',
            'new': 'blue',
            'active': 'green',
            'ended': 'silver',
            'rejected': 'red'
        };
        if (campaign.campaignType === CampaignInfluencerStatus.ARCHIVED) {
            return 'silver';
        }
        return colors[status] || 'silver';
    };
    Object.defineProperty(CampaignItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignItemComponent.prototype, "influencerList", {
        get: function () {
            if (!this.campaign || !Array.isArray(this.campaign.influencers) || this.campaign.influencers.length === 0) {
                return [];
            }
            if (AppSettings.isCampaignInfluencerDetails()) {
                this.campaign.influencers = this.campaign.influencers.sort(function (a, b) { return a.campaign_influencer_reach.value < b.campaign_influencer_reach.value ? 1 : a.campaign_influencer_reach.value > b.campaign_influencer_reach.value ? -1 : 0; });
                return this.campaign.influencers.slice(0, 3);
            }
            return this.campaign.influencers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignItemComponent.prototype, "postList", {
        get: function () {
            if (!this.campaign || this.isNewCampaign(this.campaign) || !Array.isArray(this.campaign.posts)) {
                return [];
            }
            return this.campaign.posts;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignItemComponent.prototype, "secondColData", {
        get: function () {
            if (this.enableInfluencerPlatform && this.campaign.campaignType !== CampaignInfluencerStatus.ARCHIVED) {
                return this.campaign.status;
            }
            else if (this.enableInfluencerPlatform && this.campaign.campaignType === CampaignInfluencerStatus.ARCHIVED) {
                return CampaignInfluencerStatus.DELETE;
            }
            else {
                return this.campaign.numberOfInfluencers;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignItemComponent.prototype, "canDeleteCampaign", {
        get: function () {
            if (!this.enableInfluencerPlatform) {
                return true;
            }
            return this.campaign && this.campaign.status === CampaignInfluencerStatus.NEW;
        },
        enumerable: true,
        configurable: true
    });
    CampaignItemComponent.prototype.isNewCampaign = function (campaign) {
        // only apply for influencer platform
        if (this.enableInfluencerPlatform) {
            return campaign && campaign.status === CampaignInfluencerStatus.NEW;
        }
        else {
            return false;
        }
    };
    Object.defineProperty(CampaignItemComponent.prototype, "buttonLabel", {
        get: function () {
            return this.campaign.campaignType && this.campaign.campaignType === CampaignInfluencerStatus.ARCHIVED ? CampaignInfluencerStatus.DELETE : this.translate.instant('common.btn.details');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CampaignItemComponent.prototype, "isCampaignInfluencerDetails", {
        get: function () {
            return AppSettings.isCampaignInfluencerDetails();
        },
        enumerable: true,
        configurable: true
    });
    CampaignItemComponent.prototype.requestGoToCampaignDetails = function () {
        this.goToCampaignDetails.emit();
    };
    return CampaignItemComponent;
}());
export { CampaignItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-item/campaign-item.component.ts.pre-build-optimizer.js